export const cardAdmin = {
    seeAndChange: 'Se og endre kortet ditt',
    administeredByKredittbanken: 'Våre kredittkort leveres av Kredittbanken',
    insuranceLinkTitle: 'Forsikringer',
    insuranceLinkSubtitle: 'Vilkår og forsikringsbevis',
    orderNewCardLinkTitle: 'Bestill nytt kort',
    blockCardLinkTitle: 'Sperr kort',
    details: 'Detaljer',
    blockReorderTitle: 'Sperr/erstatt kort',
} as const;
